import React from "react";
import { Grid, Skeleton } from "@mui/material";
import EquipmentTypeItem from "./EquipmentTypeItem";
import type { LocationEquipmentType } from "../../../../types/Location";

interface EquipmentTypeMapProps {
    equipmentTypeArray?: LocationEquipmentType[];
    defaultPricePerDay: number;
    defaultPricePerMonth: number;
    defaultOverageRate?: number | null;
    showOverageColumn?: boolean;
    loading: boolean;
}

const EquipmentTypeMap = (props: EquipmentTypeMapProps) => {
    const { equipmentTypeArray, defaultPricePerDay, defaultPricePerMonth, defaultOverageRate, showOverageColumn, loading } = props;
    return (
        <Grid container>
            {loading ? [...Array(4).keys()].map((_, index) => <Skeleton variant="text" key={index} />) : equipmentTypeArray?.map((asset) => <EquipmentTypeItem
                key={asset.id}
                asset={asset}
                defaultPricePerDay={defaultPricePerDay}
                defaultPricePerMonth={defaultPricePerMonth}
                defaultOverageRate={defaultOverageRate}
                showOverageColumn={showOverageColumn}
            />)}

        </Grid>
    )
}

export default EquipmentTypeMap;